import { Component, EventEmitter, Output } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import { Subscription } from 'rxjs/Subscription';
import { TareaService } from '../../../../providers/tarea.service';
import { Tarea, TareaTipo } from '../../../../interfaces/tarea';
import { Cotizacion } from '../../../../interfaces/cotizacion';
import { Usuario } from '../../../../interfaces/usuario';
import { TareaResponsable } from '../../tarea-responsables/tarea-responsable/tarea-responsable';

@Component({
  selector: 'app-listado-tareas',
  templateUrl: './listado-tareas.component.html',
  styleUrls: ['./listado-tareas.component.scss']
})
export class ListadoTareasComponent {
  actualizarTablaTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  cargandoTimeout: any;
  cargando: boolean = true; // para mostrar el progress-bar luego de un tiempo de busqueda
  getTareasSuscripcion = new Subscription();
  tareas: Tarea[] = <Tarea[]>[];
  @Output() onChange = new EventEmitter();

  constructor(
    private tareasService: TareaService
  ) { }

  onTareaChange(): void {
    this.onChange.emit();
  }

  /**
   * Traer tareas entre dos fechas
   * @param fechaDesde fecha inicial incluida
   * @param fechaHasta fecha final incluida
   */
  traerTareas(fechaDesde: Moment, fechaHasta: Moment): void {
    clearTimeout(this.actualizarTablaTimeout);
    this.actualizarTablaTimeout = setTimeout(() => {
      clearTimeout(this.cargandoTimeout);
      this.cargandoTimeout = setTimeout(() => { // mostrar cargando si tarda mas de algun tiempo de busqueda
        this.cargando = true;
      }, 750);

      if (this.getTareasSuscripcion && !this.getTareasSuscripcion.closed) {
        this.getTareasSuscripcion.unsubscribe();
      }

      this.getTareasSuscripcion = this.tareasService.getTareas(
        {
          page: null,
          pageSize: null
        },
        {
          sort: 'fechaTarea',
          order: 'desc'
        },
        {
          fechaDesde: fechaDesde.format('YYYY-MM-DD HH:mm:ss'),
          fechaHasta: fechaHasta.format('YYYY-MM-DD HH:mm:ss')
        }
      ).subscribe( // suscribimos una nueva busqueda
        respuesta => {
          this.tareas = <Tarea[]>[];
          if (respuesta.estado == 1 && respuesta.data && respuesta.data.tareas) {
            respuesta.data.tareas.forEach((tarea) => {
              this.tareas.push(
                new Tarea(
                  tarea.IdTarea,
                  tarea.titulo,
                  tarea.fechaTarea,
                  tarea.fechaTarea ? moment(tarea.fechaTarea).format('HH:mm:ss') : null,
                  tarea.fechaNotificacion,
                  tarea.fechaNotificacion ? moment(tarea.fechaNotificacion).format('HH:mm:ss') : null,
                  tarea.descripcion,
                  tarea.cantidadResponsables,
                  tarea.totalCompletadasResponsables,
                  new Cotizacion(
                    tarea.cotizacion.IdCotizacion
                  ),
                  new TareaTipo(
                    tarea.tipo.id,
                    tarea.tipo.descripcion
                  ),
                  (tarea.soyResponsable) ? new TareaResponsable(
                    tarea.soyResponsable.IdTareaResponsable,
                    new Usuario(
                      tarea.soyResponsable.usuario.IdUsuario,
                      tarea.soyResponsable.usuario.usuario,
                      null,
                      null,
                      null,
                      tarea.soyResponsable.usuario.nombre,
                      tarea.soyResponsable.usuario.apellido
                    ),
                    tarea.soyResponsable.fechaCompletada
                  ) : null
                )
              );
            });
          }
        },
        () => {
          clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
          this.cargando = false; // ocultar progress bar si se estaba mostrando
        },
        () => {
          clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
          this.cargando = false; // ocultar progress bar si se estaba mostrando
        }
      );
    }, (this.flag_primera_carga ? 0 : 220));

    this.flag_primera_carga = false;
  }

  ngOnDestroy() {
    if (this.getTareasSuscripcion && !this.getTareasSuscripcion.closed) {
      this.getTareasSuscripcion.unsubscribe();
    }
  }

  clear(): void {
    this.tareas = <Tarea[]>[];
  }
}
